import {timeFormat} from 'd3-time-format'
import {format} from 'd3-format'
import uniqid from 'uniqid'

export const createTable = (data, formatDate = true) => {
  let table = data.slice()
  table.map(row => {
    for (let value in row) {
      if (!row[value]) {
        row[value] = '-'
      }
      if (value === 'date') {
        let date = new Date(new Date(row[value]).getTime() + new Date(row[value]).getTimezoneOffset()*60000 - 4*60*60000)
        row[value] = formatDate ? timeFormat('%Y-%m-%d')(date) : date
      } else if (value === 'actual_execution_date' && row[value] != null) {
        let date = new Date(row[value])
        row[value] = date
      } else if (parseFloat(row[value])) {
        row[value] = parseFloat(row[value]) > 0.01 ? format('.2f')(parseFloat(row[value])) : format('.4r')(parseFloat(row[value]))
      }
    }
    row.key = uniqid()
  })
  return table
}

export const filterTable = (table, filter) => {
  return table.filter(row => {
    let matchedVals = 0
    for (let value in row) {
      if (row[value] && value !== 'key') {
        if (row[value].toString().toLowerCase().indexOf(filter) !== -1) {
          matchedVals++
        }
      }
    }
    return matchedVals
  })
}

export const sorterNum = (a, b) => {
  /* eslint-disable */
  let first = typeof a === 'number' ? a : parseFloat(`${a}`.replace(/[^0-9\.-]+/g,''))
  let last = typeof b === 'number' ? b : parseFloat(`${b}`.replace(/[^0-9\.-]+/g,''))
  /* eslint-enable */
  if (isNaN(first)) {
    first = Number.NEGATIVE_INFINITY
  }
  if (isNaN(last)) {
    last = Number.NEGATIVE_INFINITY
  }
  return first - last
}

export const isObject = (item) => {
  return (item && typeof item === 'object' && !Array.isArray(item))
}

export const mergeDeep = (target, ...sources) => {
  if (!sources.length) {
    return target
  }
  const source = sources.shift()

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) {
          Object.assign(target, { [key]: {} })
        }
        mergeDeep(target[key], source[key])
      } else {
        Object.assign(target, { [key]: source[key] })
      }
    }
  }

  return mergeDeep(target, ...sources)
}

export const formatCurrency = (number) => {
  return number.toLocaleString('en-US', {style: 'currency', currency: 'USD'})
}
